import { useNavigate } from 'react-router-dom'
import { useAuthStore } from '@/stores/auth_store'

export default function Header() {
  const navigate = useNavigate()
  const { admin, logOut } = useAuthStore()

  const handleLogout = async () => {
    await logOut()
    navigate('/login')
  }

  return (
    <header className="bg-header-bg bg-[var(--Stone-700)] px-6 flex items-center justify-between text-white" style={{ height: '48px'}}>
      <div >
        <img src={'/image/logo.png'} alt={'푸딩툰 로고'} onClick={()=>navigate('/members/artist')} style={{cursor:"pointer"}}></img>
      </div>
      <div className="flex items-center space-x-4">
        {admin && (
          <>
            <span className="text-sm text-white">
              { admin.name || admin.loginId} 관리자 계정
            </span>
            <button
              onClick={handleLogout}
              className="px-4 py-2 text-sm transition-colors"
            >
              로그아웃
            </button>
          </>
        )}
      </div>
    </header>
  )
}